import React, { useEffect, useState } from 'react';
import { Button, Grid, Modal } from '@material-ui/core';
import { AppTextfield } from '../parts/input/AppTextfield';
import { PreviewField } from '../fileListPage/Preview';
import { AppDatePicker } from '../parts/input/AppDatePicker';
import { formatDatetime } from '../../utils/common';
import { SelectIcon } from '../parts/cloudStorage/SelectIcon';
import VisibilityIcon from '@material-ui/icons/Visibility';
import CloseIcon from '@material-ui/icons/Close';

type Tprops = {
  file: File;
  index: number;
  setValue: any;
  deleteFile: (index: number) => void;
};

export const List: React.FC<Tprops> = (props: Tprops) => {
  const { file, index, setValue, deleteFile } = props;

  const [src, setSrc] = useState<string>('');
  const [openPreview, setOpenPreview] = useState<boolean>(false);

  //PDFプレビュー
  const previewPdf = (file: File) => {
    // const reader = new FileReader();
    setSrc(URL.createObjectURL(file));
  };

  useEffect(() => {
    // ファイルデータをhook-formに追加
    setValue(`list.${index}.upload_file`, file);
    // ファイル名をhook-formに追加
    setValue(`list.${index}.name`, file.name);
  }, [file]);

  return (
    <>
      <div style={{ padding: '24px 0', borderBottom: 'solid 1px #E6E6E6' }}>
        <Grid container justify={'center'} spacing={1}>
          {/* 入力欄（左側） */}
          <Grid item xs={11}>
            <Grid container spacing={1}>
              {/* １行目 */}
              <Grid item xs={6}>
                <div style={{ display: 'flex' }}>
                  <div style={{ minWidth: '70px', marginRight: '20px' }}>
                    書類
                  </div>
                  <div style={{ marginRight: 12 }}>
                    <SelectIcon
                      width={31}
                      height={38}
                      format={file.type}
                      name={file.name}
                    />
                  </div>
                  <div
                    style={{
                      width: '100%',
                      wordBreak: 'break-all',
                      display: 'flex',
                      alignItems: 'center'
                    }}
                  >
                    {file.name}
                  </div>
                </div>
              </Grid>

              {file.type === 'application/pdf' && (
                <Grid item xs={6}>
                  <Button
                    style={{
                      backgroundColor: '#52555F',
                      color: '#fff'
                    }}
                    variant='contained'
                    onClick={() => {
                      previewPdf(file);
                      setOpenPreview(true);
                    }}
                  >
                    <VisibilityIcon />
                    プレビュー
                  </Button>
                </Grid>
              )}

              {/* ２行目 */}
              <Grid item xs={12}>
                <div style={{ display: 'flex' }}>
                  <div style={{ minWidth: '70px', marginRight: '20px' }}>
                    日付
                  </div>
                  <AppDatePicker
                    name={`list.${index}.exchange_date`}
                    defaultValue={formatDatetime(new Date(), 'YYYY-MM-DD')}
                    style={{ width: 200 }}
                  />
                </div>
              </Grid>

              {/* 3行目 */}
              <Grid item xs={12}>
                <div style={{ display: 'flex' }}>
                  <div style={{ minWidth: '70px', marginRight: '20px' }}>
                    説明
                  </div>
                  <AppTextfield
                    name={`list.${index}.description`}
                    style={{ width: '100%' }}
                    multiline={true}
                    rows={3}
                  />
                </div>
              </Grid>
            </Grid>
          </Grid>

          {/* 削除アイコン（右側） */}
          <Grid item xs={1}>
            <div
              style={{
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}
            >
              <CloseIcon
                style={{ cursor: 'pointer' }}
                fontSize='large'
                onClick={() => deleteFile(index)}
              />
            </div>
          </Grid>
        </Grid>
      </div>

      {/* プレビュー */}
      <Modal
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%'
        }}
        open={openPreview}
        onClose={() => setOpenPreview(false)}
      >
        {/* PreviewFieldは、CONOCユーザー側のページのものと同じであるため、fileListPageディレクトリから呼び出して使用 */}
        <PreviewField
          src={src}
          openPreview={openPreview}
          setOpenPreview={setOpenPreview}
        />
      </Modal>
    </>
  );
};
